/** 計画作成/計画数入力登録 */
export const ADD_QUANTITY_PLAN_API_CONSTANT = {
  // 届先グループ名称
  DELIVERY_GROUP_NAME: 'delivery_group_name',
};
